import { Link } from '@remix-run/react'

const TlButton = (prop) => {
  return (
    <Link
      to={prop.link}
      onClick={prop.onClick}
      reloadDocument
      className={`inline-block ${prop.bgFrom && prop.bgTo ? `bg-gradient-to-r from-${prop.bgFrom} to-${prop.bgTo} hover:from-${prop.hoverColour} hover:to-${prop.hoverColour}` : ''} text-white ${prop.textSize} ${prop.border ? prop.border : ''}  ${prop.px} ${prop.py} rounded-full ${prop.w ? prop.w : ''} ${prop.onhover ? `hover:bg-${prop.onhover}` : ''} mb-6`}
    >
      {prop.text}
    </Link>
  )
}

export default TlButton
